import { render, staticRenderFns } from "./RiskAssessmentReviewAG.vue?vue&type=template&id=0382ac6a&"
import script from "./RiskAssessmentReviewAG.vue?vue&type=script&lang=js&"
export * from "./RiskAssessmentReviewAG.vue?vue&type=script&lang=js&"
import style0 from "./RiskAssessmentReviewAG.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports